var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3891 11.6109C21.537 13.7588 21.537 17.2412 19.3891 19.3891C17.2412 21.537 13.7588 21.537 11.6109 19.3891C9.46303 17.2412 9.46303 13.7588 11.6109 11.6109C13.7588 9.46303 17.2412 9.46303 19.3891 11.6109",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 11.6109C14.537 13.7588 14.537 17.2412 12.3891 19.3891C10.2412 21.537 6.75879 21.537 4.61091 19.3891C2.46303 17.2412 2.46303 13.7588 4.61091 11.6109C6.75879 9.46303 10.2412 9.46303 12.3891 11.6109",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.687C15 4.125 14.811 4.546 14.474 4.86L12.263 6.924C12.115 7.062 11.885 7.062 11.736 6.924L9.526 4.861C9.189 4.546 9 4.125 9 3.687V3.687C9 2.755 9.755 2 10.687 2H13.313C14.245 2 15 2.755 15 3.687V3.687V3.687Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.69ae3554.svg";
export { ForwardRef as ReactComponent };